module.exports = __webpack_public_path__ + "static/media/Karol_Remmel-min.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Karol_Remmel-min.jpg
// module id = 872
// module chunks = 0